module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('section', [_c('cover-image', {
    attrs: {
      "src": 'static/bg-about.jpg',
      "title": _vm.$t('pages.management.title'),
      "subtitle": ''
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "container content"
  }, _vm._l((_vm.sections), function(section, index) {
    return _c('div', {
      key: index,
      staticClass: "row section"
    }, [_c('h2', {
      staticClass: "col-12"
    }, [_vm._v(_vm._s(_vm.$t('pages.management.sections[' + index + '].title')))]), _vm._v(" "), _vm._l((section.people), function(person, yndex) {
      return _c('div', {
        key: yndex,
        staticClass: "col-lg-3 person"
      }, [_c('div', {
        staticClass: "content"
      }, [_c('img', {
        attrs: {
          "src": _vm.$t('pages.management.sections[' + index + '].people[' + yndex + '].img'),
          "alt": _vm.$t('pages.management.sections[' + index + '].people[' + yndex + '].name')
        }
      }), _vm._v(" "), _c('div', {
        staticClass: "signature"
      }, [(_vm.$t('pages.management.sections[' + index + '].people[' + yndex + '].title')) ? _c('p', {
        staticClass: "title"
      }, [_vm._v(_vm._s(_vm.$t('pages.management.sections[' + index + '].people[' + yndex + '].title')))]) : _vm._e(), _vm._v(" "), _c('h3', {
        staticClass: "name"
      }, [_vm._v(_vm._s(_vm.$t('pages.management.sections[' + index + '].people[' + yndex + '].name')))])])])])
    })], 2)
  }))], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-71f6638c"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/pages/ManagementView.vue
// module id = 511
// module chunks = 1